import isNil from 'lodash/isNil';

import { BadgeVariant } from '@ui/components/badges/Badge';

export enum VariationTone {
  GAIN = 'GAIN',
  LOSS = 'LOSS',
  NEUTRAL = 'NEUTRAL',
}

/** Tone of an amount or percentage variation: a rise, a fall, or nothing to show. */
export const getVariationTone = (variation: number | null | undefined): VariationTone => {
  if (isNil(variation) || variation === 0) {
    return VariationTone.NEUTRAL;
  }
  return variation > 0 ? VariationTone.GAIN : VariationTone.LOSS;
};

export const VARIATION_TONE_TEXT_CLASSNAMES: Record<VariationTone, string> = {
  [VariationTone.GAIN]: 'text-gain',
  [VariationTone.LOSS]: 'text-loss',
  [VariationTone.NEUTRAL]: 'text-fg-muted',
};

export const VARIATION_TONE_BADGE_VARIANTS: Record<VariationTone, BadgeVariant> = {
  [VariationTone.GAIN]: BadgeVariant.SUCCESS,
  [VariationTone.LOSS]: BadgeVariant.DESTRUCTIVE,
  [VariationTone.NEUTRAL]: BadgeVariant.SECONDARY,
};
